var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clear-data"},[_c('h2',[_vm._v("Clear Leaderboard Data?")]),_c('button',{on:{"click":_vm.clearData}},[_vm._v("Clear")])])}
var staticRenderFns = []

export { render, staticRenderFns }